export enum EnableAttachment {
    None = 0,
    SampleLevel = 1,
    OrderLevel = 2,
}
